import { useState } from "react";
import { formatINR, formatNumber } from "@/lib/units";
import ResultsPanel, { CalcPageHeader, Field } from "@/components/ResultsPanel";
import EduSection from "@/components/EduSection";

export default function PropertyROI() {
  const [cost, setCost] = useState("5000000");
  const [current, setCurrent] = useState("7500000");
  const [years, setYears] = useState("5");
  const [rent, setRent] = useState("20000");

  const totalRent = (Number(rent)||0) * 12 * (Number(years)||0);
  const gain = (Number(current)||0) - (Number(cost)||0) + totalRent;
  const roi = (Number(cost)||0) > 0 ? (gain / Number(cost)) * 100 : 0;
  const cagr = (Number(cost)||0) > 0 && Number(current) > 0 && Number(years) > 0 ? (Math.pow(Number(current)/Number(cost), 1/Number(years)) - 1) * 100 : 0;

  const rows = [
    ["Purchase Cost", formatINR(Number(cost)||0)],
    ["Current Value", formatINR(Number(current)||0)],
    ["Hold Period", `${years} years`],
    ["Total Rent Collected", formatINR(totalRent)],
    ["Total Gain", formatINR(gain)],
    ["Total ROI", `${formatNumber(roi,2)}%`],
    ["Appreciation CAGR", `${formatNumber(cagr,2)}%`],
  ];
  return (
    <div>
      <CalcPageHeader title="Property ROI Calculator" description="Total return and CAGR on a property investment across a hold period." slug="property-roi" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-7">
          <div className="rounded-lg border border-border bg-card p-5 sm:p-6 grid grid-cols-2 gap-4">
            <Field label="Purchase Cost (₹)"><input data-testid="roi-cost" type="number" value={cost} onChange={(e)=>setCost(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <Field label="Current Value (₹)"><input data-testid="roi-current" type="number" value={current} onChange={(e)=>setCurrent(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <Field label="Hold Period (years)"><input data-testid="roi-years" type="number" value={years} onChange={(e)=>setYears(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <Field label="Monthly Rent (₹)"><input data-testid="roi-rent" type="number" value={rent} onChange={(e)=>setRent(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
          </div>
        </div>
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <ResultsPanel title="Property ROI" slug="property-roi" highlight={{ label: "Appreciation CAGR", value: `${formatNumber(cagr,2)}%`, sub: `Total ROI ${formatNumber(roi,2)}%` }} rows={rows} />
        </div>
      </div>
      <EduSection howItWorks={<p>Total ROI = (Capital gain + rent) ÷ purchase cost. CAGR annualises appreciation alone: (End ÷ Start)<sup>1/n</sup> − 1.</p>} related={["rental-yield","warehouse-rent","loan-emi"]} />
    </div>
  );
}
